/* eslint-disable import/prefer-default-export */
export const ES = {
  es: {
    generals: {
      seework: "Ver el trabajo | {1} Ver los trabajos",
      offices: "Todas las oficinas",
      read: "Lea el artículo",
      related: "Projectos Relacionados",
      "related-news": "Noticias recientes",
      readmore: "Lea más",
      seemore: "Veja mais",
      getcontact: "Entrar en contacto",
      ourclients: "Nuestros clientes",
      apply: "Postúlese",
      jobsfounded: "Próximamente, en breve, pronto...",
      error: "Algo salió mal, intenta de nuevo...",
      employeesfounded: "No se encontraron empleados...",
      clientsfounded: "No se encontraron clientes...",
      newsfounded: "No se encontraron noticias...",
      contactsfounded: "No se encontraron contactos...",
    },
    menus: {
      work: "Trabajos",
      news: "Noticias",
      about: "Sobre",
      contact: "Contacto",
    },
    search: {
      placeholder: "¿Qué estás buscando?",
      results: "resultado encontrado | {2} resultados encontrados",
      filter: "Filtro",
      columns: {
        offices: "Oficina",
        types: "Tipo",
        customers: "Cliente",
        years: "Años",
      },
    },
    singleWork: {
      office: "Oficina",
      date: "Fecha",
      client: "Cliente",
    },
    footer: {
      copyright: "Todos los derechos reservados",
      followus: "Síguenos en",
      weare: "Somos",
    },
    contact: {
      talkwithus: "Contáctenos",
      workwithus: "Únase a <br /> nuestro <br/> equipo",
      talents: "Nuevos talentos",
      talentdescription:
        "Ven a trabajar a la agencia más creativa del mundo. <br/> O si tú no crees que esta es la agencia más creativa del mundo: <br/> Ven a trabajar a David. Esta es tu oportunidad de hacer que se convierta en la agencia más creativa del mundo.",
      general: "Contacto general",
      vacanciesnotfound:
        "Por el momento no tenemos un proceso de selección abierto, <br/>pero siempre puedes enviarnos un saludo.",
    },
  },
};
